<template>
	<div class="independent-wrapper">
		<div class="content" ref="box">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 历史列表
			</div>
			<div class="contentLeft">
				<div class="tab-container tab" v-if="role == 0 || role == 2">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index)">
							{{ item }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
<!--							<el-form-item class="el-form-item-line " label="所属机构">
								<el-select @change="changeHospitalName" v-model="searchData.hospitalName" filterable
									placeholder="请选择">
									<el-option v-for="item in hospitalList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line " label="检查人员">
								<el-select v-model="searchData.realName" filterable placeholder="请选择">
									<el-option v-for="item in realNameList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>-->
							<el-form-item class="el-form-item-line date" label="测量时间">
								<el-form-item class="line" prop="startDate">
									<el-date-picker size="large" value-format="YYYY-MM-DD" format="YYYY-MM-DD" type="date"
										placeholder="开始日期" v-model="searchData.startDate"></el-date-picker>
								</el-form-item>
								<span class="line line-10">-</span>
								<el-form-item class="line endDate" prop="endDate">
									<el-date-picker size="large" value-format="YYYY-MM-DD" format="YYYY-MM-DD" placeholder="结束日期"
										v-model="searchData.endDate"></el-date-picker>
								</el-form-item>
							</el-form-item>
							<el-form-item class="el-form-item-line " label="患者姓名">
								<el-input v-model="searchData.name" placeholder="请输入患者姓名"></el-input>
							</el-form-item>

							<el-form-item class="el-form-item-line " label="体质">
								
								<el-select v-model="searchData.physiqueId" placeholder="请选择">
									<el-option value="">请选择</el-option>
									<el-option
									  
								      v-for="item in physiqueList"
								      :key="item.id"
								      :label="item.name"
								      :value="item.id">
								    </el-option>
								  </el-select>
								
							</el-form-item>		
							<el-form-item class="el-form-item-line " label="舌象结果">
								<el-select v-model="searchData.tongueReportResultId" placeholder="请选择">
									<el-option value="">请选择</el-option>
									<el-option
									  
								      v-for="item in resultOptions"
								      :key="item.result"
								      :label="item.result"
								      :value="item.id">
								    </el-option>
								  </el-select>
							</el-form-item>
											
							<!-- <el-form-item class="el-form-item-line " label="面象诊断">
								<el-input v-model="searchData.facePic" placeholder="请输入面象诊断查询"></el-input>
							</el-form-item> -->
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="searchBtn" @click="onSearch">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%;cursor: pointer;"
							@selection-change="handleSelectionChange" :data="tableListData" @row-click="viewReport">
<!--							<el-table-column align="center" label="所属机构" prop="hospitalName">
							</el-table-column>-->
							
							<el-table-column align="center" label="检查人员" prop="doctor">
							</el-table-column>
							<el-table-column align="center" label="患者姓名" prop="patientName">
							</el-table-column>
              <el-table-column align="center" label="患者电话" prop="patientPhone">
              </el-table-column>
							
							<el-table-column align="center" label="诊断体质" prop="physique">
								
								<template #default="{row}">
									<div>
										{{ row.physique ? row.physique : "暂无" }}
									</div>
								</template>
							</el-table-column>
							
							<el-table-column align="center" label="测量时间" prop="visitTime">
							</el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<span class="editor">
									查看报告
								</span>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" :page-size="10"
										layout="prev, pager, next, jumper" :total="total">
									</el-pagination>
								</div>
								<div class="data">
									共<span>{{ totalPage }}</span>页/<span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	
	export default {
		data() {
			return {
				
				searchData: {
					startDate: "", //开始日期
					endDate: "", //结束日期
					hospitalName: "", //医疗机构
					realName: "", //检查人员
					name: "", //患者姓名
					physiqueId: "", //舌象
					tongueReportResultId:'',//舌下
				},
				tabList: ["机构查询", "平台查看"],
				currentTabIndex: 1,
				role: "",
				currentPage: 1, //当前页
				totalPage: 1, //总页数
				total: 1, //总数据
				tableListData: [],
				hospitalList: [],
				realNameList: [],
				scroll: 0,
				resultOptions:[],
				physiqueList:[]
			};
		},

		methods: {
			//路由切换
			goOther(index) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/historyList/historyList",
					});
				}
				if (this.role == 0 || this.role == 2) {
					if (index == 1) {
						this.$router.push({
							path: "/historyList/reportOverview",
						});
					}
				} else {
					if (index == 1) {
						this.$router.push({
							path: "/historyList/reportHos",
						});
					}
				}
			},
			//重置
			reset() {
				this.searchData = {
					startDate: "", //开始日期
					endDate: "", //结束日期
					hospitalName: "", //医疗机构
					realName: "", //检查人员
					name: "", //患者姓名
					physiqueId: "", //舌象
					tongueReportResultId:'',//舌下
					id:''
				};
				this.gethistroyList();
			},
			//搜索功能
			onSearch() {
				if (this.searchData.endDate < this.searchData.startDate) {
					alert("结束时间不能小于开始时间");
					return false;
				}
				this.currentPage = 1;
				this.gethistroyList();
			},
			//获取机构列表POST /business/user/hospital/list
			getHospitalList(name) {
				this.$post("/business/user/hospital/list")
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.hospitalList = res.data.data;
							this.hospitalList[0] = "请选择";
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//切换机构
			changeHospitalName(val) {
				if (val == "请选择") {
					this.getRealNameList("");
				} else {
					this.getRealNameList(val);
				}
			},
			//获取检查人员
			getRealNameList(hospital) {
				this.$post("/business/user/realName/list?hospital=" + hospital + "")
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.realNameList = res.data.data;
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取历史列表
			gethistroyList() {
				this.$applicationJson("/admin/visit/result/paging", {
						current: this.currentPage,
						orderBy: "",
						params: {
							doctor: this.searchData.realName,
							patientName: this.searchData.name,
							hospital: this.searchData.hospitalName,
							physiqueId:this.searchData.physiqueId,
							tongueReportResultId:this.searchData.tongueReportResultId,
							statDateL: this.searchData.startDate,
							statDateR: this.searchData.endDate,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							this.total = res.data.data.total;
							this.totalPage = res.data.data.pages;
							for (let i = 0; i < this.tableListData.length; i++) {
								if (!this.tableListData[i].hospital) {
									this.tableListData[i].hospital = "---";
								}
								if (!this.tableListData[i].realName) {
									this.tableListData[i].realName = "---";
								}
							}
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.gethistroyList();
			},
			//选中的列表
			handleSelectionChange() {},
			viewReport(item) {
				// console.log(item)
				this.$router.push({
					path: "/historyList/viewReport",
					query: {
						visitId: item.visitId
					},
				});
			},
			//获取报告结果列表
			getPlanList(currentPage) {
				this.$applicationJson("/business/baseReportResult/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							result: '',
						},
						size: 100,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.resultOptions = res.data.data.records;
							
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取体质列表
			getPhysiqueList(currentPage) {
				this.$applicationJson("/business/base/physique/paging", {
						current: currentPage,
						orderBy: "",
						params: {},						
						size: 100,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.physiqueList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(2, 3);
					this.currentTabIndex = 1;
				} else {
					//this.tabList.splice(1, 1);
				}
				this.getPlanList(0);
				this.getHospitalList();
				this.getRealNameList("");
				this.getPhysiqueList(0);
				this.gethistroyList();
				
			});
		},
		activated() {
			this.$refs.box.scrollTop = this.scroll;
			this.gethistroyList();
		},
		beforeRouteLeave(to, from, next) {
			if (to.name != "viewReport") {
				to.meta.keepAlive = false				
			} else {
				this.scroll = this.$refs.box.scrollTop;
			}
			next();
		}, 
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		width: 100%;

		// .tab 样式继承自 mentor.less（el-tabs 风格的二级菜单）

		.content {
			overflow-y: auto;
			overflow-x: hidden;

			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.demo-form-inline {
					margin-top: 10px;
				}

				.search-con {
					height: 120px;
					@media screen and (min-width: 0px) and (max-width: 1060px) {
						height: 180px;
						width: 100%;
					}
					@media screen and (min-width: 1060px) and (max-width: 1200px) {
						height: 180px;
						width: 100%;
					}
					 @media (min-width: 1920px) {
					 	width: 100%;
					 	height: 120px;
					 }
					:deep(.el-select){
						width: 160px;
					}
					
				}
			}
		}
		.editor {
			cursor: pointer;
			color: #679ff6;
		}
	}
</style>
